export type Theme = 'light' | 'dark' | 'pink';
const storageKey = 'contur-crm-theme';
const isTheme = (value: unknown): value is Theme => value === 'light' || value === 'dark' || value === 'pink';
let transitionTimer:ReturnType<typeof setTimeout>|undefined;

export function readTheme(): Theme {
  try {
    const saved = localStorage.getItem(storageKey);
    if (saved !== null) return isTheme(saved) ? saved : 'light';
  } catch { /* Theme selection also works with browser storage disabled. */ }
  const current = document.documentElement.dataset.theme;
  return isTheme(current) ? current : 'light';
}

export function applyTheme(theme: Theme, animate=false) {
  const root=document.documentElement;
  if(animate&&root.dataset.theme!==theme){
    root.classList.add('theme-transitioning');
    clearTimeout(transitionTimer);
    transitionTimer=setTimeout(()=>{root.classList.remove('theme-transitioning');transitionTimer=undefined;},500);
  }
  root.dataset.theme = theme;
  try { localStorage.setItem(storageKey, theme); } catch { /* Keep the selection for this page. */ }
}
